import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useWindowSize } from 'react-use';
import classnames from 'classnames';
import { useScrollbarStyles } from 'modules/common/styles';
import { useSidePanelContext } from 'modules/rootPage/SidePanelContext';
import { useInstalledCollectorSettings } from './hooks';
import { InstalledCollectorsEmptyPage } from './InstalledCollectorList/InstalledCollectorsEmptyPage';
import InstalledCollectorsListPage from './InstalledCollectorList/InstalledCollectorsListPage';
import { useCollectorBroadcast } from './Install/hooks';

type InstalledCollectorsTabProps = {
  isAdmin: boolean;
};

type PageStyleProps = {
  width: number;
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    height: 'inherit',
    overflowX: 'auto',
    width: ({ width }: PageStyleProps) => width
  }
}));

export const InstalledCollectorsTab: React.FC<InstalledCollectorsTabProps> = memo(
  ({ isAdmin }: InstalledCollectorsTabProps) => {
    const {
      data,
      loading,
      refetch,
      loadMore
    } = useInstalledCollectorSettings();

    useCollectorBroadcast({ onBroadcast: refetch });
    const { pinned = false } = useSidePanelContext();
    const { width } = useWindowSize();
    const classes = useStyles({
      width: pinned ? width - 240 : width - 64
    });
    const classesScrollbar = useScrollbarStyles();
    if (!loading && !data?.collectorSettings?.items?.length)
      return <InstalledCollectorsEmptyPage />;

    return (
      <div className={classnames(classes.root, classesScrollbar.scrollbar)}>
        <InstalledCollectorsListPage
          isAdmin={isAdmin}
          loading={loading}
          data={data}
          loadMore={loadMore}
        />
      </div>
    );
  }
);

InstalledCollectorsTab.displayName = 'InstalledCollectorsTab';
